function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDcLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-d559e7e0-7b7d-43a3-810c-29573d3f0699",
    xmlns: "http://www.w3.org/2000/svg",
    width: 270.6,
    height: 76.7,
    viewBox: "0 0 270.6 76.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m0,38c0-6.7,1.8-12,5.3-16.1,3.4-4,8.5-6.2,13.8-6,1.7,0,3.4.2,5.1.7,1.3.3,2.6.9,3.8,1.6.9.6,1.7,1.3,2.4,2,.5.5,1,1.1,1.5,1.7l.3.7h.2c-.1-.9-.2-1.9-.2-2.8V.1h8.1v59h-7.7v-4l.1-2.8h-.2c-.1.2-.3.5-.5.8-.4.7-.9,1.3-1.4,1.9-.8.9-1.6,1.7-2.6,2.4-1.2.8-2.6,1.5-4,1.9-1.8.6-3.6.9-5.4.8-5.2.2-10.2-2.1-13.5-6.1C1.7,49.9,0,44.6,0,38Zm8.2,0c0,4.6,1.1,8.2,3.3,11,2.1,2.7,5.3,4.2,8.7,4.1,3.3.1,6.5-1.3,8.7-3.8,2.3-2.5,3.5-6.3,3.5-11.4.1-3.8-1-7.5-3.1-10.6-2-2.9-5.3-4.6-8.8-4.5-3.4,0-6.6,1.4-8.7,4.1-2.4,2.7-3.6,6.4-3.6,11.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.1,8.4V.1h8.2v8.3s-8.2,0-8.2,0Zm.1,50.7V16.8h8.1v42.3h-8.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.6,66.8c3.6,1.9,7.6,2.9,11.6,2.8,4,0,7.2-1,9.7-2.9s3.7-4.9,3.7-9v-3.1l.1-2.7h-.2c-2.6,4.4-6.8,6.6-12.5,6.6s-10.3-2-13.7-6.1c-3.4-4.1-5.1-9.2-5.1-15.5s1.6-11.3,4.9-15.2c3.3-4,7.8-5.9,13.5-5.9,1.8,0,3.5.2,5.3.6,1.4.3,2.7.8,3.8,1.6.9.6,1.7,1.2,2.4,1.9.5.4,1,1,1.3,1.6l.4.6h.2c-.1-.4-.1-.9-.1-1.3v-3.9h7.8v40.5c.1,3-.5,6.1-1.8,8.9-1.1,2.4-2.8,4.5-4.9,6s-4.3,2.6-6.8,3.3c-2.5.7-5.2,1.1-7.8,1.1-5,0-10-1.2-14.5-3.5,0,0,2.7-6.4,2.7-6.4Zm14-15.2c3.1.1,6-1.2,8.1-3.4,2.1-2.3,3.1-6,3.1-11.1,0-9.5-4-14.2-12-14.2-3.3-.2-6.4,1.2-8.5,3.7-2,2.5-3,5.9-3,10.2s1.1,8,3.3,10.7c2.2,2.7,5.5,4.2,9,4.1h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.4,8.4V.1h8.2v8.3s-8.2,0-8.2,0Zm.1,50.7V16.8h8.1v42.3h-8.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.5,38c-.2-5.9,2.2-11.6,6.4-15.8,4.3-4.2,9.7-6.4,16.2-6.4,3,0,5.9.5,8.6,1.5,2.1.7,4,1.8,5.6,3.1l1.6,1.5-3.9,5.7c-.3-.3-.8-.8-1.5-1.3-1.2-.9-2.6-1.6-4-2.2-2-.9-4.1-1.3-6.2-1.3-3.9-.1-7.8,1.4-10.5,4.3-2.8,2.9-4.3,6.8-4.2,10.8-.1,4,1.4,7.9,4.2,10.9,2.8,2.9,6.7,4.5,10.7,4.3,2.3,0,4.6-.5,6.8-1.4,1.7-.7,3.3-1.6,4.8-2.8l1.5-1.4,3.3,5.9-.7.7c-.6.6-1.3,1.1-2.1,1.6-1.1.8-2.2,1.4-3.4,2-1.5.7-3.1,1.2-4.7,1.6-2,.5-4,.8-6,.8-6.6,0-12.1-2.1-16.3-6.3-4.1-4.2-6.4-9.9-6.2-15.8h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m162,38c0-6.6,2-12,6-16,4-4.1,9.5-6.3,15.2-6.1,5.7,0,10.2,1.9,13.4,5.6s4.8,8.5,4.9,14.2l-.3,3.5h-30.9c.2,4.4,1.7,7.9,4.5,10.3,2.8,2.4,6.4,3.7,10.1,3.6,2.2,0,4.4-.4,6.4-1.2,1.6-.6,3.2-1.4,4.6-2.4l1.5-1.2,3.4,5.9c-.6.6-1.3,1.2-2,1.7-1.8,1.1-3.6,2-5.6,2.7-2.8,1.1-5.8,1.7-8.8,1.7-6.6,0-11.9-2.1-16.1-6.3-4.2-4.4-6.4-10.1-6.3-16h0Zm8.6-5h22.6c-.1-3.5-1.1-6.2-3.1-8-1.9-1.9-4.5-2.9-7.2-2.8-3-.1-5.9.9-8.1,2.8-2.3,2.1-3.8,4.9-4.2,8h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.3,59.1V16.8h7.9v7.4l-.2,3.2h.2c.9-3.1,2.7-5.8,5.1-7.9,2.3-2,5.3-3.1,8.3-3.1l2.1.2v8c-.8-.2-1.6-.3-2.3-.2-2.6,0-5.2,1-7.2,2.7-2.3,1.9-3.9,4.4-4.7,7.3-.7,2.5-1,5-1,7.6v17.3h-8.2v-.2h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241,43.6v-19.7h-5.5v-6.5h5.8V5.2h7.9v12.2h10.2v6.5h-10.2v18.8c0,1.4.2,2.9.7,4.2.3,1,.9,2,1.6,2.8.6.7,1.4,1.2,2.2,1.6.7.4,1.5.6,2.3.8.7.1,1.4.2,2.1.2l1.9-.2v7.2c-.9.1-1.9.2-2.8.2-1.3,0-2.6-.1-3.8-.2-1.4-.2-2.8-.7-4.2-1.2-1.5-.6-2.9-1.5-4.1-2.6-1.3-1.3-2.3-2.9-2.9-4.6-.9-2.5-1.3-4.9-1.2-7.3h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.5,0c-3.4,0-6.1,2.8-6.1,6.1s2.8,6.1,6.1,6.1,6.1-2.7,6.1-6.1c.1-3.4-2.7-6.1-6.1-6.1h0m0,11c-2.7,0-4.9-2.2-4.9-4.9s2.2-4.9,4.9-4.9,4.9,2.2,4.9,4.9h0c0,2.7-2.2,4.9-4.9,4.9h0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.4,9.5V2.7h2.1c.4,0,.9,0,1.3.2.3.1.6.4.8.7.2.3.3.7.3,1.2,0,.4-.1.8-.3,1.2-.2.3-.5.6-.9.7h0c.1.1.1.2.2.3l1.4,2.6h-1.1l-1.4-2.8h-1.5v2.7h-.9Zm.9-3.5h1.4c.3,0,.6-.1.9-.3.2-.2.3-.6.3-.9,0-.4-.2-.8-.5-1-.3-.1-.6-.2-.9-.2h-1.1v2.4h-.1,0Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcLogoWhite);
export default __webpack_public_path__ + "static/media/DC_logo_white.93faf67f.svg";
export { ForwardRef as ReactComponent };